<script setup>
import {ref, onBeforeMount} from "vue"
import {orderStateEnum} from "@/enum/orderStateEnum.js"
const props = defineProps({
  state: {
    required: true,
    type: String,
    default: "INIT"
  }
})

// 执行订单判断
onBeforeMount(() => {
  handleEnum()
})

// 展示的文本类型
const textType = ref("info")
// 状态名称
const stateName = ref("未知状态")
// 订单状态枚举
const orderState = orderStateEnum

// 根据枚举返回订单状态
const handleEnum = () => {
  try {
    const order = orderState.find(res => res.stateId === props.state)
    stateName.value = order.stateName ? order.stateName : "未知状态"
    switch (props.state) {
      case "COMPLETED":
        textType.value = "success"
        break
      case "REFUNDED":
        textType.value = "danger"
        break
      case "REFUNDING":
        textType.value = "warning"
        break
      case "DELIVERING":
        textType.value = "primary"
        break
      case "READY_FOR_PICKUP":
        textType.value = "warning"
        break
      case "PREPARING":
        textType.value = "primary"
        break
      case "WAIT_ACCEPT":
        textType.value = "warning"
        break
      case "UNPAID":
        textType.value = "warning"
        break
      case "PAID":
        textType.value = "success"
        break
      case "REGISTERED":
        textType.value = "primary"
        break
      case "PARTIAL_REFUNDED":
        textType.value = "warning"
        break
      case "AVAILABLE":
        textType.value = "primary"
        break
      case "NORMAL":
        textType.value = "primary"
        break
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <el-text :type="textType" v-text="stateName"></el-text>
</template>

<style scoped>

</style>